import {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
} from "../../../constants/constants";

export const validatePassword = (val) => {
  if (!val) return "Password is required.";
  if (val.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (val.length > MAX_PASSWORD_LENGTH) {
    return `Password must not exceed ${MAX_PASSWORD_LENGTH} characters.`;
  }
  if (/\s/.test(val)) return "Password cannot contain spaces.";
  if (val.includes("..") || val.includes("__")) {
    return "Password cannot contain consecutive dots or underscores.";
  }

  return "";
};
